module.exports = __webpack_public_path__ + "/login_ui/img/ag-0263bb55e2939ec9238b14cac67048a5.svg";